import React from "react";
import EditorComponent from "./EditorComponent";
import { classNames } from "../../../helpers/classNames";

const Editor = ({
  height,
  imageUploadApi,
  uploadApiMethod,
  value,
  onChange = () => {},
  label,
  labelClasses,
  required,
}) => {
  return (
    <div className="relative">
      {label && (
        <div
          className={classNames(
            "text-xs font-medium text-text-disabled font-CanelaDeck mb-1",
            labelClasses
          )}
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      <EditorComponent
        fontFamilies={["Italianno", "Orbitron", "Silkscreen", "Space+Grotesk"]}
        height={height}
        imageUploadApi={imageUploadApi}
        uploadApiMethod={uploadApiMethod}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default Editor;
